import styled from '@emotion/styled';
import { NestedMenu, NestedMenuItem, theme } from '@ublend-npm/aulaui-next';

export const NestedMenuItemText = styled.span`
  line-height: ${theme.font.lineHeight.large};
  padding: 0px;
  font-family: ${theme.font.family.workSans};
  display: inline-block;
  margin-left: 8px;
  width: 100%;
  font-size: ${theme.font.size.copy};
  color: ${theme.color.designSystem.blackOpacity87};
`;

export const MenuItemContainer = styled.div`
  color: ${theme.color.designSystem.blackOpacity60};
  font-family: ${theme.font.family.workSans};
  font-size: ${theme.font.size.copy};
  padding: 0;
  pointer-events: auto;
`;

export const NestedMenuContainer = styled(NestedMenu)`
  padding: 0;
`;

export const WrappedMenuItem = styled(NestedMenuItem)`
  height: 45px;
  color: ${theme.color.designSystem.blackOpacity60};
  display: flex;
  min-width: 200px;
  box-sizing: border-box;
`;
